/**
 *  Site actions module file
**/

import { ACTIONS, MUTATIONS } from './constants'
import api from '@/api/api'

export const actions = {
  [ACTIONS.FETCH_CONFIG] ({ commit }) {
    api.get('/sites').then(res => {
      const config = res.data && res.data.profile
      if (config) {
        commit(MUTATIONS.SET_CONFIG, config)
      }
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('[site/actions.js] Error fetching site config ', err)
    })
  },
  [ACTIONS.FETCH_BACK_LINK] ({ commit }, { payload }) {
    commit(MUTATIONS.SET_BACK_LINK, payload)
  },
  [ACTIONS.SET_BILLING_NOTIFICATION] ({ commit }, { payload }) {
    commit(MUTATIONS.SAVE_BILLING_NOTIFICATION, payload)
  }
}
